import React from 'react';

import { GuestSmartAssistantAccessibilityGuard } from 'pages/GuestSmartAssistant/components/GuestSmartAssistantAccessibilityGuard';
import { GuestSmartAssistantDataValidationGuard } from 'pages/GuestSmartAssistant/components/GuestSmartAssistantDataValidationGuard';
import { GuestDashboard } from 'pages/GuestSmartAssistant/GuestDashboard/GuestDashboard';
import { useParams } from 'react-router';

export function GuestSmartAssistantDashboardPage() {
  const { smartAssistantId } = useParams();

  return (
    <GuestSmartAssistantAccessibilityGuard smartAssistantId={smartAssistantId} type="dashboard">
      {smartAssistantId && (
        <GuestSmartAssistantDataValidationGuard smartAssistantId={smartAssistantId}>
          {(guestSmartAssistantData, avatarUrl) => {
            return <GuestDashboard smartAssistant={guestSmartAssistantData.smartAssistant} avatarUrl={avatarUrl} />;
          }}
        </GuestSmartAssistantDataValidationGuard>
      )}
    </GuestSmartAssistantAccessibilityGuard>
  );
}
